<!-- <app-survay-header></app-survay-header> -->
<div class="Main-Cont">
    <div class="Ques-cont">
        <div class="text-dark fs-5 fw-bold">
            <!-- What is your Age&#63; -->
            {{qService.currentQuestion.question_text}}
        </div>
        <div class="text-muted fs-6 fw-normal mt-2">
            Please write your answer in numeric
        </div>
        <div class="row Image-Cont">
            <div class="form-group">
                <!-- <input class="Form-input" type="text" [(ngModel)]="ansBody.answer_text" placeholder="Your Answer Here:" /> -->
                <div class="input-container">
                    <input class="Form-input" type="text" #input placeholder="Your Answer Here:" value={{value}} (input)="onInputChange($event)" />
                    <div (click)="onCloseKeboard()" *ngIf="isKeyboardReInstanciated"><i class="fa fa-keyboard-o on" aria-hidden="true"></i></div>
                    <div (click)="onOpenKeyboard()" *ngIf="!isKeyboardReInstanciated"><i class="fa fa-keyboard-o off" aria-hidden="true"></i></div>
                </div>
                <!-- <input #input on-focus="onInputFocus()" on-focusout="DeChange()" class="input" value={{value}} placeholder="Tap on the virtual keyboard to start" (input)="onInputChange($event)" /> -->
            </div>
        </div>
    </div>
    
    <div class="footer-container">
        <div class="simple-keyboard" #simpleKeyboardRef></div>

        <div class="footer">
            <div class="text-start">
                <!-- <i class="fa fa-keyboard-o" aria-hidden="true"></i> -->
                <!-- <button class="btn btn-primary" (click)="onCloseKeboard()" *ngIf="isKeyboardReInstanciated">Off</button>
                <button class="btn btn-primary" (click)="onOpenKeyboard()" *ngIf="!isKeyboardReInstanciated">On</button> -->
            </div>
            <div class="text-center">
                <div class="text-dark fw-bold fs-4">Q{{qService.currentQuestion.ques_index}}</div>
            </div>
            <div class="text-end">
                <button class="btn btn-primary" (click)="next()">Next</button>
            </div>
        </div>
    </div>
</div>
